<template>
  <v-container class="pa-0" fluid>
    <v-card flat>
      <v-sheet class="pa-4 alba lighten-1">
        <v-text-field
          v-model="search"
          clearable
          dark
          dense
          flat
          hide-details
          label="Căutare"
          solo-inverted
        ></v-text-field>
      </v-sheet>

      <v-card-text>
        <v-treeview
          v-model="tree"
          :active.sync="active"
          :items="departamente"
          :search="search"
          activatable
          color="blue"
          dense
          independent
          item-key="name"
          open-on-click
          return-object
          rounded
        >
          <template slot="label" slot-scope="{ item }">
            <v-btn
              :ripple="false"
              text
              small
              @click="fetchExternalHtmlDocument(item)"
              
            >
              {{ item.name }} 
              <!-- <em v-if="item.formular" class="formular_label">{{ item.formular}}</em> -->
            </v-btn>
          </template>

          <template slot="append" slot-scope="{ item }">
              <em v-if="item.formular" class="formular_label">{{ item.formular}}</em>
          </template>
        </v-treeview>
      </v-card-text>
    </v-card>
    <v-dialog
      id="content"
      v-model="dialog"
      no-click-animation
      overlay-opacity="0.8"
      persistent
      fullscreen
      transition="dialog-top-transition"
      max-width="800"
    >
      <v-card v-model="selectedItem" flat>
        <v-system-bar color="systembar lighten-1" height="50" fixed>
          <v-btn class="ma-2" tile outlined color="success" @click="closeDialog" id="goHomeBtn">
            <v-icon left size="19">home</v-icon>Catalog servicii electronice
          </v-btn>
        </v-system-bar>
        
        
        <div style="position: relative">
          <div v-html="content" style="padding-top: 20px"></div>

          <div class="contentToggle">
            <v-menu
              :allow-overflow="true"
              nudge-top="4"
              transition="fade-transition"
              :open-on-click="false"
              :open-on-hover="true"
            >
              <template v-slot:activator="{ on }">
                <v-btn color="blue" outlined tile v-on="on">Cuprins</v-btn>
              </template>

              <v-card max-width="300">
                <v-list color="rgba(255, 202, 0, 0.4)" dense flat subheader>
                  <v-divider class="ma-1" />

                  <v-list-item
                    v-for="(header, i) in headers"
                    :key="i"
                    :href="header.id"
                    dense
                    link
                    color="purple"
                  >
                    <v-list-item-content class="pa-0 caption font-weight-bold">{{ header.text }}</v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
          </div>

        </div>

      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
import config from "@/utils/config";

export default {
  name: "Departament",
  data() {
    return {
      active: [],
      anchor: false,
      baseURL: null,
      content: "",
      dialog: false,
      departamente: [],
      headers: [],
      search: null,
      selectedItem: {},
      tree: []
    };
  },

  created: function() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      let _this = this;
      _this.baseURL = config.baseURL;
      axios.get("data.json").then(response => {
        _this.processData(response.data);
      });
    },

    processData(data) {
      let _this = this;
      data.departamente.forEach(departament => {
        _this.departamente.push(departament);
      });
    },

    fetchExternalHtmlDocument(data) {
      let _this = this;
      _this.baseURL = config.baseURL;

      if (data.children === undefined) {
        _this.selectedItem = data;
        axios.get(data.html).then(response => {
          _this.prepareContentForModalDialog(response.data);
          _this.createTableOfContents(response.data);
        });
      }
    },

    prepareContentForModalDialog(data) {
      this.content = data;
      this.openDialog();
    },

    createTableOfContents(data) {
      let _this = this;
      let parser = new DOMParser();
      let doc = parser.parseFromString(data, "text/html");
      let contents = doc.getElementsByTagName("h4");

      Array.from(contents).forEach(function(item) {
        _this.headers.push({ id: "#" + item.id, text: item.innerHTML });
      });
    },

    openDialog() {
      this.dialog = true;
    },

    closeDialog() {
      this.dialog = false;
      this.active = [];
      this.headers.length = 0;

      this.$router.replace("/");
    },

    goHome() {
      window.location = "#";
    }
  }
};
</script>

<style scoped lang="scss">
.v-btn {
  letter-spacing: 0.01em;
}

.v-btn:before {
  display: none;
}

.contentToggle {
  position: fixed;
  top: 200px;
  right: -12px;
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
}
.formular_label {
  margin: 0 0 0 1.2em;
  // background: #ffca00;
  background: #415d80;
  font-size: 0.77em;
  text-transform: lowercase;
  padding: 5px;
  color: #bebebe;
  border-radius: 1px;
  line-height: 1.5;
}
</style>